import { useState, useRef } from "react";
import { Switch } from "@headlessui/react";
import { api, getFonts } from "../../../../services/axios";
import axios from "axios";
import { classNames } from "../helpers";
import { toast } from "sonner";
let uuid = require("uuid");

type UploadMessages = {
  status: boolean;
  message: string;
};

export function FileUploader({
  cid,
  user,
  callback,
}: {
  cid: string;
  user: any;
  callback: () => void;
}) {
  let [allowUpload, setAllowUpload] = useState(false);
  let [uploadMessages, setUploadMessages] = useState<UploadMessages[] | []>([]);
  const checkRef = useRef(null);
  const designRef = useRef(null);

  let [upload, setUpload] = useState({
    template_name: "",
    created_at: null,
    configurable: false,
    file_name: "",
    file_url: "",
    id: new Date().getTime().toString() + "-" + uuid.v4(),
    check_file_name: "",
    original_file_name: "",
    check_file: null,
    design_file: null,
    file_progress: 0,
    design_colors: [],
  });

  const clearUploaders = () => {
    const prefix = new Date().getTime().toString();
    setUpload({
      template_name: "",
      created_at: null,
      configurable: false,
      file_name: "",
      file_url: "",
      id: prefix + "-" + uuid.v4(),
      check_file_name: "",
      original_file_name: "",
      check_file: null,
      design_file: null,
      file_progress: 0,
      design_colors: [],
    });
    setUploadMessages([]);
    setAllowUpload(false);
  };

  const handleDesignUploadChange = (e: any) => {
    return setUpload({
      ...upload,
      file_name: e.target.files[0].name,
      design_file: e.target.files[0],
    });
  };

  const handleCheckFileUploadChange = (e: any) => {
    return setUpload({
      ...upload,
      check_file_name: e.target.files[0].name,
      check_file: e.target.files[0],
    });
  };

  const handleCheckFileUpload = async () => {
    if (upload.check_file) {
      // @ts-ignore
      if (upload.check_file.type !== "text/plain") {
        return toast.success("bad file", { duration: 5000 });
      }

      let fileReader = new FileReader();

      const handleFileRead = async () => {
        const content = fileReader.result;

        // @ts-ignore
        let getLineBreakChar = function (string) {
          const indexOfLF = string.indexOf("\n", 1); // No need to check first-character
          if (indexOfLF === -1) {
            if (string.indexOf("\r") !== -1) return "\r";
            return "\n";
          }
          if (string[indexOfLF - 1] === "\r") return "\r\n";
          return "\n";
        };

        let tsvJSON = function (tsv: any) {
          let breakChar = getLineBreakChar(tsv);
          // replace any line breaks that are part of the text itself
          let textBreak = breakChar + " ";
          tsv = tsv.replace(new RegExp(textBreak, "g"), "");
          let lines = tsv.split(breakChar);
          let result = [];
          let headers = lines[0].split("\t");
          for (let i = 1; i < lines.length; i++) {
            let obj = {};
            let currentline = lines[i].split("\t");
            for (let j = 0; j < headers.length; j++) {
              // @ts-ignore
              obj[headers[j]] = currentline[j];
            }
            result.push(obj);
          }
          return JSON.stringify(result); //JSON
        };

        // convert to JSON and do the compare
        if (typeof content === "string") {
          let json = tsvJSON(content);

          let data = JSON.parse(json);

          let checkPromises = data
            .filter(function (row: any) {
              return row.type === "text";
            })
            .map(async function (row: any) {
              const fontName = row.other;

              const query = (await getFonts()) as any;
              const find = query.fonts.includes(fontName);

              if (!find) {
                toast.error(`${fontName} font not available`, {
                  duration: 5000,
                });
              } else {
                toast.success(`${fontName} font ready`, {
                  duration: 5000,
                });
              }
            });

          let resultOfCheckPromise = (await Promise.all(
            checkPromises
          )) as UploadMessages[];

          let findFailed = resultOfCheckPromise.filter(
            (x: UploadMessages) => x.status === false
          );

          let findSuccess = resultOfCheckPromise.filter(
            (x: UploadMessages) => x.status === true
          );

          if (findFailed.length > 0) {
            setAllowUpload(false);
            setUploadMessages(findFailed);
          } else if (findSuccess.length > 0) {
            setAllowUpload(true);
            setUploadMessages(findSuccess);
            let colorPromises = data
              .filter(function (row: any) {
                return row.type === "color";
              })
              .map(async function (row: any) {
                let d = row.default;
                let c = d.split("]")[0];
                let colorSpec = c.replace(/[\[\]']+/g, "");
                return colorSpec;
              });
            let resultOfColorPromises = (await Promise.all(
              colorPromises
            )) as any[];

            setUpload({
              ...upload,
              // @ts-ignore
              design_colors: resultOfColorPromises,
            });
          } else {
            toast("No font found, click yes to continue anyways", {
              action: {
                label: "Continue",
                onClick: () => setAllowUpload(true),
              },
            });
          }
        }
      };
      fileReader.onloadend = handleFileRead;
      if (!upload.check_file) {
        return;
      }
      // @ts-ignore
      fileReader.readAsText(upload.check_file);
    } else {
      toast.error(`you need both files`, {
        duration: 5000,
      });
    }
  };

  const handleDesignFileUpload = async () => {
    if (!user) {
      toast.error("please log in", { duration: 5000 });
      return;
    }
    if (!upload.design_file || !upload.check_file) {
      toast.error(`you need both files`, {
        duration: 5000,
      });
      return;
    }
    try {
      const fileName = `${cid.replace(/\_/g, "-") + "-" + uuid.v4()}.ai`;
      const response = await api.post(`design-files/upload`, {
        fileName,
        contentType: "image/*",
      });
      const config = {
        headers: {
          "Content-Type": "image/*",
        },
        onUploadProgress: function (progressEvent: any) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUpload({
            ...upload,
            id: fileName,
            file_progress: percentCompleted,
          });
        },
      };
      const res = await axios.put(
        response.data.url,
        upload.design_file,
        config
      );
      console.log("upload result", res);
      await api
        .post("design-files", {
          author: user,
          campaign: cid,
          file_name: fileName,
          created_at: new Date().getTime().toString(),
          configurable: upload.configurable,
          original_file_name: upload.file_name,
          file_url: `https://s3.us-west-1.amazonaws.com/${process.env.REACT_APP_DESIGN_FILES_BUCKET}/${fileName}`,
          design_colors: upload.design_colors,
        })
        .then(() => {
          toast.success("File Uploaded", { duration: 5000 });
          clearUploaders();
          return callback();
        })
        .catch((e) => toast.error(e.message, { duration: 5000 }));
    } catch (e: any) {
      console.log(e);
      toast.error(`${JSON.stringify(e.message)}`, {
        duration: 5000,
      });
    }
  };

  const handleConfigurationReady = (configurable: boolean) => {
    return setUpload({
      ...upload,
      configurable: configurable,
    });
  };

  return (
    <div className="w-full p-8 m-4 border rounded">
      <div className="flex-1 min-w-0 w-full">
        <h4 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
          File Upload
        </h4>
      </div>
      <div className="w-full flex flex-col">
        <div className="w-full flex flex-col p-4">
          {uploadMessages && uploadMessages.length > 0 && (
            <div className="flex w-full">
              {/* @ts-ignore */}
              {uploadMessages.map(function (
                font: UploadMessages,
                index: number
              ) {
                return (
                  <div
                    className={
                      font.status
                        ? "font-bold text-emerald-700"
                        : "font-bold text-red-700"
                    }
                    key={index}
                  >
                    <div className="flex flex-row justify-between items-center">
                      {font.status ? (
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                      ) : (
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </div>
                      )}
                      {font.message}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <div className="w-full flex flex-col my-4">
            <p className="text-lg leading-6 font-medium text-gray-900 py-2">
              1. Checker File
            </p>
            <p className="italic text-sm">
              First upload the checker file derived from Illustrator. This
              provides the system with PMS colors and validates the fonts you
              have selected exist in the server. You can also validate the fonts
              manually by going to the fonts list page.
            </p>
            <input
              id="check_file"
              type="file"
              ref={checkRef}
              onChange={handleCheckFileUploadChange}
            />
          </div>
          <div className="flex flex-row justify-between">
            <button
              onClick={handleCheckFileUpload}
              className="bg-black px-4 py-2 text-white my-4"
              disabled={!upload.check_file}
            >
              upload check file
            </button>
          </div>
        </div>

        <div className="opacity-100 w-full flex flex-col p-4">
          <div className="w-full flex flex-col">
            <p className="text-lg leading-6 font-medium text-gray-900 py-2">
              2. AI File
            </p>
            <p className="italic text-sm">
              Next, upload the Illustrator file you used to design. Be sure this
              matches the check file you previously uploaded.
            </p>
            <div className="flex flex-row just">
              <input
                id={upload.id}
                type="file"
                ref={designRef}
                onChange={handleDesignUploadChange}
              />
              <p className="p-4">{upload.file_progress}%</p>
            </div>
          </div>
          <Switch.Group as="div" className="py-5">
            <div className="mt-2 sm:flex sm:items-start">
              <Switch.Label
                as="h3"
                className="text-lg leading-6 font-medium text-gray-900"
                passive
              >
                Is this file Configurable?
              </Switch.Label>
              <div className="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex">
                <Switch
                  checked={upload.configurable}
                  onChange={() =>
                    handleConfigurationReady(!upload.configurable)
                  }
                  className={classNames(
                    upload.configurable ? "bg-black" : "bg-gray-200",
                    "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
                  )}
                >
                  <span
                    aria-hidden="true"
                    className={classNames(
                      upload.configurable ? "translate-x-5" : "translate-x-0",
                      "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                    )}
                  />
                </Switch>
              </div>
            </div>
          </Switch.Group>
          <div className="flex flex-row justify-betweenr">
            <button
              onClick={handleDesignFileUpload}
              className="bg-black px-4 py-2 text-white my-4"
              disabled={!upload.design_file}
            >
              upload design file
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
